<template>
  <newsForm :typeEndPoint="'schoolRoutesNewsForm'" :dataParams="{}"/>
</template>
<script>
import newsForm from '@/components/modules/schoolroutes/news/form'
export default {
  name: 'newsFormCreate',
  components: {
    newsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/news/create.vue